const UPDATE_INSTALLED = 'update-installed';

let registered = false;

function register(callback: (eventName: string) => void): () => void {
  if (
    registered ||
    process.env.NODE_ENV !== 'production' ||
    !('serviceWorker' in navigator)
  )
    return () => {};

  registered = true;

  const publicUrl = new URL(
    process.env.PUBLIC_URL || '',
    window.location.origin,
  );
  if (publicUrl.origin !== window.location.origin) return () => {};

  const swUrl = `${process.env.PUBLIC_URL || ''}/service-worker.js`;

  let updatefoundHandler: (() => void) | null = null;
  let registrationRef: ServiceWorkerRegistration | null = null;
  let isCleanedUp = false;

  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      registrationRef = registration;

      if (isCleanedUp) return;

      if (registration.waiting && navigator.serviceWorker.controller) {
        callback(UPDATE_INSTALLED);
        return;
      }

      updatefoundHandler = () => {
        const newWorker = registration.installing;
        if (!newWorker) return;
        newWorker.addEventListener('statechange', () => {
          if (
            newWorker.state === 'installed' &&
            navigator.serviceWorker.controller
          ) {
            callback(UPDATE_INSTALLED);
          }
        });
      };

      registration.addEventListener('updatefound', updatefoundHandler);
    })
    .catch((err) => console.error('SW registration failed:', err));

  return () => {
    isCleanedUp = true;
    if (registrationRef && updatefoundHandler) {
      registrationRef.removeEventListener('updatefound', updatefoundHandler);
      updatefoundHandler = null;
    }
  };
}

export default { register };
